import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/** Datos que el backend envía para renderizar un anuncio, ya resueltos por ambiente. */
export type AnnouncementData = Record<string, string>;

export type AnnouncementsResponse = Record<string, { show: boolean, data?: AnnouncementData }>;

@Injectable({ providedIn: 'root' })
export class AnnouncementsService {
  private readonly url = '/:apiBase/announcements';

  constructor(private http: HttpClient) {}

  check(): Observable<AnnouncementsResponse> {
    return this.http.get<AnnouncementsResponse>(this.url);
  }
}
